import { render } from "./component-pref-fac.vue?vue&type=template&id=76334f0b"
import script from "./component-pref-fac.vue?vue&type=script&setup=true&lang=js"
export * from "./component-pref-fac.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-pref-fac.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76334f0b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76334f0b', __exports__)) {
    api.reload('76334f0b', __exports__)
  }
  
  module.hot.accept("./component-pref-fac.vue?vue&type=template&id=76334f0b", () => {
    api.rerender('76334f0b', render)
  })

}


export default __exports__